export default {
  dashboard: "Dashboard",

  cashRegisterManagement: "Kassenverwaltung",
  cashRegisters: "Kassen",
  keyboardLayouts: "Tastaturlayouts",
  cashRegisterSystemConfiguration: "Kassensystemeinstellungen",

  masterData: "Stammdatenverwaltung",
  mainAndArticleGroups: "Haupt- und Warengruppen",
  articles: "Artikel",
  discounts: "Rabatte",
  paymentMethods: "Zahlungsarten",
  cashFlows: "Geldbewegungen",

  operatorManagement: "Bedienerverwaltung",

  contactManagement: "Adressverwaltung",

  clients: "Kunden",

  receiptOverview: "Belegübersicht",

  analysis: "Auswertungen",
  articleReport: "Artikelbericht",
  groupReport: "Gruppenbericht",
  accountingReport: "Buchhaltungsbericht",
  cashFlowReport: "Geldbewegungsbericht",
  cashRegisterLedgerReport: "Buchungsjournal",
  closeOfDay: "Tagesabschluss",

  protocols: "Protokolle",
  cashRegister: "Kasse",
  management: "Verwaltung",

  rksv: "RKSV",
  financeOnline: "FinanzOnline",
  export: "Export",
  receipts: "Belege",
} as const
